<template>
  <div class="upset-box" v-show="show">
    <div class="upset-detail">
      <div
        class="upset-scroll"
        :style="{ height: buttonListLength ? '395px' : '460px' }"
      >
        <div class="datail-item border-none">
          <div class="title">
            <div class="title-left"></div>
            <div class="title-right">
              <img src="@/assets/image/Home/topGamesIco.png" />
              <bargainPublicity :contentText="bargainPublicityText" :number="rowDetail.number" :detailsData="rowDetail.new_bargain_list"></bargainPublicity>
              <!-- 当前<span class="color-yellow">{{ rowDetail.number }}</span
              >位买家正在议价 -->
            </div>
          </div>
        </div>
        <div class="datail-item">
          <div class="title">
            <div class="title-left">订单编号</div>
            <div class="title-right">
              <span class="price-text">{{
                rowDetail.earnest_order_no
              }}</span>
            </div>
          </div>
        </div>
        <div class="datail-item">
          <div class="title">
            <div class="title-left">求降信息</div>
            <!-- <div class="title-right">
              <img src="@/assets/image/Home/topGamesIco.png" />
              当前<span class="color-yellow">{{ rowDetail.number }}</span
              >位买家正在议价
            </div> -->
          </div>
          <div class="content">
            <div class="content-left">
              <span class="color-999">诚意买</span>
              <span class="color-D3D3D3"
                >诚意买为当前价格的{{ percentage }}%</span
              >
            </div>
            <div class="content-right">
              <div class="refund" v-show="rowDetail.status == 2 && rowDetail.step == 0">
                已取消
              </div>
              <div class="refund" v-show="rowDetail.status == 0 && !rowDetail.pay_time">
                未付款
              </div>
              <span class="price-text">￥{{ rowDetail.earnest_amount }}</span>
            </div>
          </div>
          <!-- <div class="content" v-show="rowDetail.new_reserve_price > 0 || rowDetail.counter_status == 4 || rowDetail.counter_status == 2">
            <div class="content-left" v-show="rowDetail.new_reserve_price > 0">
              当前底价<span class="price-text"
                >￥{{ rowDetail.new_reserve_price }}</span
              >
            </div>
            <div class="content-left" v-show="rowDetail.tail_order_pay_time">
              最终价格<span class="price-text"
                >￥{{ rowDetail.deal_price }}</span
              >
            </div>
            <div
              class="content-right"
              v-show="
                rowDetail.counter_status == 4 || rowDetail.counter_status == 2 || rowDetail.counter_status == 1
              "
            >
              买家出价<span class="price-text"
                >￥{{ rowDetail.buyer_price }}</span
              >
              <div class="refund" v-show="rowDetail.counter_status == 2">
                已拒绝
              </div>
            </div>
            <div class="content-right" v-show="rowDetail.counter_status == 4">
              {{isBuyer ? '卖家还价' : '我的还价'}}<span class="price-text"
                >￥{{ rowDetail.seller_price }}</span
              >
            </div>
          </div> -->
          <div class="content" v-show="rowDetail.new_reserve_price > 0 && rowDetail.step < 4">
            <div class="content-left">
              <span class="color-999">当前底价</span>
            </div>
            <div class="content-right">
              <span class="price-text">￥{{rowDetail.new_reserve_price}}</span>
            </div>
          </div>
          <div class="content" v-show="newReservePriceShow">
            <div class="content-left">
              <span class="color-999">当前底价</span>
            </div>
            <div class="content-right">
              <span class="price-text">￥????</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.counter_status == 4">
            <div class="content-left">
              <span class="color-999">{{isBuyer ? '卖家还价' : '我的还价'}}</span>
            </div>
            <div class="content-right">
              <span class="price-text">￥{{ rowDetail.seller_price }}</span>
            </div>
          </div>
          <div class="content" v-show="
                rowDetail.counter_status == 4 || rowDetail.counter_status == 2 || rowDetail.counter_status == 1
              ">
            <div class="content-left">
              <span class="color-999">{{isBuyer ? '我的出价' : '买家出价'}}</span>
            </div>
            <div class="content-right">
              <div class="refund" v-show="rowDetail.counter_status == 2">
                已拒绝
              </div>
              <span class="price-text">￥{{ rowDetail.buyer_price }}</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.tail_order_pay_time">
            <div class="content-left">
              <span class="color-999">尾款</span>
            </div>
            <div class="content-right">
              <div class="refund" v-show="!rowDetail.tail_order_pay_time">
                待付款
              </div>
              <span class="price-text">￥{{ rowDetail.balance_amount }}</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.tail_order_add_time">
            <div class="content-left">
              <span class="color-999">{{ isBuyer ? '实付金额' : '到手价'}}</span>
            </div>
            <div class="content-right">
              <span class="price-text color-F29234"><span>￥</span>{{  isBuyer ? rowDetail.order_amount : rowDetail.pay_amount }}</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.refund_status == 1 && isBuyer">
            <div class="content-left color-6BADF8 refund-text">
              <i class="el-icon-warning"></i>
              全款金额将在2个工作日内原路退回，请注意查收！
            </div>
          </div>
        </div>
        <!-- <div class="datail-item">
          <div class="title">
            <div class="title-left">订单信息</div>
            <div class="title-right">
              <span class="color-999">订单编号</span>
              <span class="price-text">{{ rowDetail.earnest_order_no }}</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.counter_status == 3">
            <div class="content-left">
              <span class="color-999">商品成交价</span>
            </div>
            <div class="content-right">
              <span class="price-text">￥{{ rowDetail.deal_price }}</span>
            </div>
          </div>
          <div class="content">
            <div class="content-left">
              <span class="color-999">诚意买</span>
              <span class="color-D3D3D3"
                >诚意买为当前价格的{{ percentage }}%</span
              >
            </div>
            <div class="content-right">
              <span class="price-text">￥{{ rowDetail.earnest_amount }}</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.status == 1">
            <div class="content-left">
              <span class="color-999">已付尾款</span>
            </div>
            <div class="content-right">
              <span class="price-text">￥{{ rowDetail.balance_amount }}</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.status == 1">
            <div class="content-left">
              <span class="color-999">包赔</span>
            </div>
            <div class="content-right">
              <span class="price-text">￥{{ rowDetail.indemnity_amount }}</span>
            </div>
          </div>
          <div class="content" v-show="rowDetail.status == 1">
            <div class="content-left">
              <span class="color-999">实付金额</span>
            </div>
            <div class="content-right">
              <span class="price-text color-F29234"
                ><span>￥</span>{{ rowDetail.order_amount }}</span
              >
            </div>
          </div>
        </div> -->
        <div class="datail-item">
          <div class="title">
            <div class="title-left">商品详情</div>
          </div>
          <div class="content">
            <div class="content-left">
              <span class="color-999">商品编号</span>
              <span :class="[rowDetail.tail_order_pay_time ? 'price-text' : 'text-underline']" @click="goDetail">{{
                rowDetail.unique_no
              }}</span>
            </div>
            <div class="content-right">
              <span class="color-999">商品价格</span>
              <span class="price-text">￥{{ rowDetail.product_price }}</span>
            </div>
          </div>
          <div class="content">
            <div class="content-left">
              <span class="color-999">游戏名称</span>
              <span class="price-text">{{ rowDetail.game_name }}</span>
            </div>
          </div>
        </div>
        <div class="timeline-wrapper">
          <div class="title">操作记录</div>
          <!-- 卖家未发送账密-买家已申请验号需要判断下方div高度 -->
          <div class="timeline-list">
            <div
              class="timeline-list-item"
              :class="{ 'timeline-list-item-grey': index !== 0 }"
              v-for="(item, index) in rowDetail.logs"
              :key="item.time"
            >
              <div class="timeline-list-item-time">
                {{ item.dateShow ? item.date : "" }}
              </div>
              <div class="timeline-list-item-line">
                <div class="tag"><div></div></div>
                <div class="line"></div>
              </div>
              <div class="timeline-list-item-card">
                <div class="timeline-list-item-card-head">{{ item.time }}</div>
                <div class="timeline-list-item-card-content">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="upset-group-btn">
        <slot name="btn"></slot>
      </div>
    </div>
    <div class="close">
      <img
        src="@/assets/image/AccountDeal/close.png"
        @click="$emit('update:show', false)"
      />
    </div>
  </div>
</template>

<script>
import bargainPublicity from "@/components/bargainPublicity"
export default {
  name: "downturnDeailDia",
  components: {
    bargainPublicity
  },
  props: {
    // 是否显示
    show: {
      type: Boolean,
      default: false,
    },
    // 详情
    rowDetail: {
      type: Object,
      default: () => {},
    },
    //  是否买家
    isBuyer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {
    show(val) {
      if (val) {
        this.touchmoveDisable();
      } else {
        this.touchmoveY();
      }
    },
  },
  computed: {
    bargainPublicityText(){
      return `当前<span style="color: #f29234;font-size: 20px;font-weight: 600;">${this.rowDetail.number}</span>位买家正在议价`
    },
    percentage() {
      return (
        (this.rowDetail.earnest_amount / this.rowDetail.product_price) *
        100
      ).toFixed(2);
    },
    buttonListLength() {
      return this.isBuyer ? this.rowDetail?.button_list?.length > 0 || 
      this.rowDetail.refund_status == 0 || 
      (this.rowDetail.refund_type === 1 && this.rowDetail.refund_status === 1) || 
      (this.rowDetail.refund_type === 2 && this.rowDetail.refund_status === 1) || 
      this.rowDetail.refund_status == 3 : this.rowDetail?.button_list?.length > 0;
    },
    newReservePriceShow() {
      return this.rowDetail?.button_list?.indexOf(5)>=0
    }
  },
  methods: {
    // goBuyerDetail(){
    //   this.touchmoveY()
    //   this.$router.push({
    //     path: "/personalCenter/buyer/payDetail",
    //     query: {
    //       id: this.rowDetail.order_id,
    //     },
    //   });
    // },
    /**
     * @description: 禁止页面滑动
     * @return {*}
     */
    touchmoveDisable() {
      let body = document.getElementsByTagName("body");
      body[0].style.overflow = "hidden";
    },
    /**
     * @description: 页面滑动
     * @return {*}
     */
    touchmoveY() {
      let body = document.getElementsByTagName("body");
      body[0].style.removeProperty("overflow");
    },
    goDetail() {
      if(this.rowDetail.tail_order_pay_time) return false
      this.touchmoveY()
      this.$router.push({
        path: "/gamedetails",
        query: {
          game_id: this.rowDetail.game_id,
          id: this.rowDetail.product_id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.upset-box {
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.48);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .upset-detail {
    width: 422px;
    height: 500px;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    background: var(--bg-card, #fff);
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;
    filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));
    .upset-scroll {
      flex: 1 1 auto;
      min-height: 0;
      height: auto !important;
      padding: 18px 16px 12px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 4px; /* 滚动条宽度 */
      }

      &::-webkit-scrollbar-track {
        background-color: transparent; /* 滚动条背景色 */
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--border-strong, #D8D2CA); /* 滚动条滑块颜色 */
        border-radius: 4px;
      }
    }
    .datail-item {
      margin-bottom: 12px;
      padding: 14px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.05);
      .title {
        min-height: 24px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        &-left {
          color: var(--text-main, #111827);
          text-align: left;
          font-family: PingFang SC;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.5px;
        }
        &-right {
          min-height: 24px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          color: var(--text-secondary, #5A5F6B);
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          img {
            width: 20px;
            height: 20px;
            flex: 0 0 20px;
            margin-right: 4px;
          }
          .color-yellow {
            color: var(--primary, #FF5A1F);
            font-family: PingFang SC;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            padding: 0 3px;
          }
          /deep/ span[style*="color"] {
            padding: 0 3px;
          }
        }
      }
      .content {
        min-height: 28px;
        margin-top: 8px;
        padding: 8px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        color: var(--text-secondary, #5A5F6B);
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        flex-wrap: wrap;
        background: var(--bg-tag, #F0EDE8);
        border: 1px solid transparent;
        border-radius: 4px;
        &-left {
          flex: 1 1 0;
          min-width: 0;
          min-height: 24px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          line-height: 24px;
        }
        &-right {
          flex: 0 0 auto;
          max-width: 100%;
          min-height: 24px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-wrap: wrap;
          line-height: 24px;
          .refund {
            border-radius: 4px;
            background: var(--primary-soft, #FCEDE5);
            min-width: 56px;
            height: 22px;
            padding: 0 8px;
            text-align: center;
            line-height: 22px;
            margin-left: 5px;
            color: var(--hot, #FF2D55);
            font-family: PingFang SC;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            letter-spacing: 0.28px;
          }
        }
      }
    }
    .border-none{
      padding: 10px 14px;
      border: 1px solid var(--bg-tag, #F0EDE8);
      background: var(--bg-tag, #F0EDE8);
      box-shadow: none;

      .title {
        margin-bottom: 0;
      }

      .title-right {
        width: 100%;
        justify-content: center;
        color: var(--text-main, #1A1D24);
      }
    }
    .price-text {
      display: inline-flex;
      align-items: center;
      min-width: 0;
      color: var(--text-main, #111827);
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      margin-left: 5px;
      word-break: break-all;
      &.color-F29234 {
        color: var(--primary, #FF7A1A);
        font-size: 20px;
        span {
          color: var(--primary, #FF7A1A);
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    .refund-text{
      i{
        width: 12px;
        height: 12px;
        font-size: 12px;
      }
    }
    .color-6BADF8{
      color: var(--text-main, #1A1D24);
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.24px;
    }
    .color-999 {
      display: inline-flex;
      align-items: center;
      color: var(--text-secondary, #5A5F6B);
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .color-D3D3D3 {
      display: inline-flex;
      align-items: center;
      color: var(--text-muted, #9AA0AC);
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-left: 5px;
    }
    .color-F29234 {
      color: var(--primary, #FF7A1A);
    }
    .text-underline {
      display: inline-flex;
      align-items: center;
      min-width: 0;
      color: var(--text-main, #1A1D24);
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration-line: underline;
      margin-left: 5px;
      cursor: pointer;
      word-break: break-all;
    }
    .timeline-wrapper {
      margin-bottom: 0;
      padding: 14px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.05);

      .title {
        color: var(--text-main, #111827);
        font-family: PingFang SC;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.5px;
      }
      .timeline-list {
        height: auto;
        max-height: none;
        margin-top: 8px;

        &-item {
          display: flex;
          min-height: 52px;
          // margin: 0 0 12px;
          &-time {
            margin: 10px 0 0;
            color: var(--text-main, #111827);
            text-align: right;
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            min-width: 86px;
            flex: 0 0 86px;
            white-space: nowrap;
          }
          &-line {
            margin: 12px 12px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            .tag {
              margin: 0 0 6px;
              width: 16px;
              height: 16px;
              border-radius: 4px;
              background: #ffffff;
              opacity: 1;
              border: 1px solid rgba(26, 29, 36, .22);
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              div {
                width: 8px;
                height: 8px;
                border-radius: 4px;
                background: var(--bg-dark, #1A1D24);
              }
            }
            .line {
              width: 2px;
              height: 100%;
              background: linear-gradient(
                180deg,
                var(--bg-dark, #1A1D24) 0%,
                rgba(26, 29, 36, 0) 100%
              );
              border-radius: 4px;
            }
          }
          &-card {
            min-width: 0;
            padding: 10px 0 12px;
            &-head {
              margin: 0 0 5px;
              color: var(--text-muted, #9AA0AC);
              font-family: PingFang SC;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
            &-content {
              white-space: pre-wrap;
              color: var(--text-main, #111827);
              font-family: PingFang SC;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px;
            }
          }
        }
        &-item-grey {
          .timeline-list-item-time {
            color: #999;
          }
          .timeline-list-item-line {
            .tag {
              border: 1px solid #c7c7c7;
              div {
                background: #ffffff;
              }
            }
            .line {
              background: linear-gradient(
                  180deg,
                  #e1e1e1 0%,
                  rgba(225, 225, 225, 0) 100%
                ),
                linear-gradient(180deg, #e1e1e1 0%, rgba(225, 225, 225, 0) 100%);
            }
          }
          .timeline-list-item-card {
            .timeline-list-item-card-head {
              color: #c1c1c1;
            }
            .timeline-list-item-card-content {
              color: #999999;
            }
          }
        }
      }
    }
    .upset-group-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      flex: 0 0 auto;
      min-height: 68px;
      margin-top: 0;
      padding: 14px 20px 16px;
      background: var(--bg-card, #FFFFFF);
      border-top: 1px solid var(--border-soft, #E8E4DE);
      .btn {
        display: flex;
        min-width: 64px;
        height: 32px;
        padding: 0 14px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: var(--bg-card, #FFFFFF);
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
      .el-button + .el-button {
        margin-left: 0;
      }
      .border-5B5B5B {
        border-color: var(--bg-dark, #1A1D24);
      }
      .bg-FFDB51 {
        border-color: transparent;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        box-shadow: 0 6px 14px rgba(255, 90, 31, 0.16);
      }
    }
  }
  .close {
    margin-top: 10px;
    img {
      cursor: pointer;
      width: 30px;
      height: 30px;
    }
  }
}
</style>
